import { createContext } from 'react';

const PatentContentContext = createContext({
  document: null,
  updatedCitedByUrl: '',
  getTrackingAttrs: () => {},
});

export default PatentContentContext;
